import store from '@/store'

export default async (to, from, next) => {
  if (!store.getters['order/order'].id) {
    next({ name: 'home' });
  } else {
    next();
  }
}
